
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1382|1896|7170|8318|9636)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
